import { useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import {
  Card,
  Grid,
  Box,
  Typography,
  Divider,
  Avatar,
  Tooltip,
  TextField,
  Button,
  CardHeader,
} from "@material-ui/core";

import { Edit, WhatsApp, Close } from "@mui/icons-material";

import componentStyles from "assets/theme/views/admin/react-bs-table.js";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import MaskAndValid from "utils/maskAndValid";
import Api from "lib/api/httpRequestHelper";
import { useEffect } from "react";

const useStyles = makeStyles(componentStyles);

export default function Clients({
  idVendedor,
  idLoja,
  isMobile,
  isMobile500,
  customerInfo,
  customerDetail,
  customerCharacteristics,
  setCustomerCharacteristics,
}) {
  const classes = useStyles();
  const snackbar = useSnackbar();

  const [editCharacteristics, setEditCharacteristics] = useState(false);
  const [submiting, setSubmiting] = useState(false);
  const [formatPhone, setFormatPhone] = useState("");

  const TypographyItem = ({ label, space }) => {
    return (
      <Typography
        variant="body2"
        style={{ marginBottom: space ? "0.5rem" : 0 }}
      >
        {label}
      </Typography>
    );
  };

  const handleSaveCustomerCharacteristics = async () => {
    setSubmiting(true);

    try {
      const res = await Api.post(
        "characteristics-create",
        "action",
        {
          IdPessoaLoja: idLoja?.toString(),
          Cpf: customerDetail?.Cpf,
          Caracteristica: customerCharacteristics,
          IdLojaVendedor: idVendedor,
        },
        true
      );
      if (res?.Success) {
        snackbar.showMessage(`Característica editada com sucesso!`, {
          severity: "success",
        });
      }
    } catch (error) {
      snackbar.showMessage(error, {
        severity: "error",
      });    } finally {
      setSubmiting(false);
      setEditCharacteristics(false);
    }
  };

  useEffect(() => {
    console.log("customerDetail", customerDetail);
    if (customerDetail?.Celular) {
      setFormatPhone(customerDetail?.Celular?.replace(/[^\d]+/g, ""));
    }
  }, [customerDetail]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={isMobile ? 12 : 4} style={{ width: "100%" }}>
        <Card>
          <CardHeader
            title="Dados Cadastrais"
            titleTypographyProps={{ variant: "h3" }}
          />

          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={2} style={{ display: "flex", alignItems: "center" }}>
                  <Avatar
                    hidden={isMobile500}
                    alt={customerDetail?.Nome}
                    src={customerDetail?.UrlPerfil}
                  />
                </Grid>
                <Grid item xs={10}>
                  <Typography variant="h3" style={{ marginBottom: "0.5rem" }}>
                    {customerDetail?.Nome}
                  </Typography>
                  {formatPhone && (
                    <TypographyItem
                      label={`${MaskAndValid.maskCPF(customerDetail?.Cpf)}`}
                      space={true}
                    />
                  )}
                </Grid>
              </Grid>

              <TypographyItem
                label={`${customerDetail?.Email ? customerDetail?.Email : " "}`}
                space={true}
              />
              <a
                href={`https://wa.me/55${formatPhone}`}
                target="_blank"
                style={{ color: "inherit" }}
                rel="noreferrer"
              >
                <Typography
                  variant="body2"
                  style={{ marginBottom: "0.5rem", cursor: "pointer" }}
                >
                  {customerDetail?.Celular}
                  <WhatsApp fontSize="small" />
                </Typography>
              </a>
              <TypographyItem
                label={`${
                  customerDetail?.DtNascimento
                    ? customerDetail?.DtNascimento
                    : " "
                } ${
                  customerDetail?.Idade
                    ? " (" + customerDetail?.Idade + " anos)"
                    : ""
                }`}
                space={true}
              />
              <TypographyItem
                label={`${customerDetail?.Bairro} - ${customerDetail?.Cidade} / ${customerDetail?.Uf}`}
                space={false}
              />
            </Grid>
          </Grid>
        </Card>

        <Card classes={{ root: classes.cardRoot }} style={{ display: "flex" }}>
          <Grid item xs={12} style={{ marginTop: "0.75rem" }}>
            <Box component={Typography} variant="h3" marginBottom="0!important">
              <Box component="span">Características do Cliente</Box>
            </Box>
          </Grid>
          <Divider style={{ margin: "0.85rem 0" }} />
          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "0.75rem",
            }}
          >
            {editCharacteristics ? (
              <TextField
                fullWidth
                multiline
                rows={3}
                value={customerCharacteristics}
                onChange={(e) => setCustomerCharacteristics(e.target.value)}
                variant="outlined"
                style={{ marginRight: "0.5rem" }}
              />
            ) : (
              <Typography variant="body2" style={{ flex: 1 }}>
                {customerCharacteristics || "Nenhuma característica cadastrada"}
              </Typography>
            )}
            <Box style={{ display: "flex", alignItems: "center" }}>
              {editCharacteristics ? (
                <>
                  <Tooltip title="Salvar">
                    <Button
                      size="small"
                      onClick={handleSaveCustomerCharacteristics}
                      disabled={submiting}
                    >
                      <Edit fontSize="small" />
                    </Button>
                  </Tooltip>
                  <Tooltip title="Cancelar">
                    <Button
                      size="small"
                      onClick={() => setEditCharacteristics(false)}
                      disabled={submiting}
                    >
                      <Close fontSize="small" />
                    </Button>
                  </Tooltip>
                </>
              ) : (
                <Tooltip title="Editar">
                  <Button
                    size="small"
                    onClick={() => setEditCharacteristics(true)}
                  >
                    <Edit fontSize="small" />
                  </Button>
                </Tooltip>
              )}
            </Box>
          </Grid>
        </Card>
      </Grid>

      <Grid item xs={isMobile ? 12 : 8} style={{ width: "100%" }}>
        <Card classes={{ root: classes.cardRoot }} style={{ display: "flex" }}>
          <Grid item xs={12} style={{ marginTop: "0.75rem" }}>
            <Box component={Typography} variant="h3" marginBottom="0!important">
              <Box component="span">Informações do Cliente</Box>
            </Box>
          </Grid>
          <Divider style={{ margin: "0.85rem 0" }} />
          <Grid
            item
            xs={12}
            style={{
              padding: "0.75rem",
              maxHeight: "400px",
              overflowY: "auto",
            }}
          >
            {customerInfo?.length > 0 ? (
              customerInfo.map((item, index) => (
                <Box key={index} style={{ marginBottom: "1rem" }}>
                  <Typography variant="h4" style={{ fontWeight: "bold" }}>
                    {item.Titulo}
                  </Typography>
                  <Typography variant="body2">{item.Descricao}</Typography>
                  {index < customerInfo.length - 1 && (
                    <Divider style={{ margin: "1rem 0" }} />
                  )}
                </Box>
              ))
            ) : (
              <Typography variant="body2">
                Nenhuma informação cadastrada para este cliente
              </Typography>
            )}
          </Grid>
        </Card>
      </Grid>
    </Grid>
  );
}
